import { render, staticRenderFns } from "./ZwyHotelConnection.vue?vue&type=template&id=6c61783b&scoped=true"
import script from "./ZwyHotelConnection.vue?vue&type=script&lang=js"
export * from "./ZwyHotelConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c61783b",
  null
  
)

export default component.exports